module.exports = __webpack_public_path__ + "static/media/pedestrian-mall.4bebd048.jpg";